$('.dropdown-label').on('click', function (e) {
    e.stopPropagation();

    if ($(this).hasClass('open')) {
        $(this).attr('aria-expanded', 'false').removeClass('open');
    }
    else {
        $('.dropdown-label.open').attr('aria-expanded', 'false').removeClass('open');
        $('.dropdown-content.show').removeClass('show');
        $(this).attr('aria-expanded', 'true').addClass('open');
    }

    var dataTarget = $(this).data('target');
    $('#' + dataTarget).toggleClass('show');

});

$(document).on('click',function () {
    $('.dropdown-label.open').attr('aria-expanded', 'false').removeClass('open');
    $('.dropdown-content.show').removeClass('show');
});